"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const formik_1 = require("formik");
const core_1 = require("@material-ui/core");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const OrderedList_1 = __importDefault(require("./OrderedList"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    input: {
        padding: '16px 12px 17px !important',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}));
const RenderOrderedAutocompleteField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue }, label, listTitleDesc, listTitleItem, isFile, placeholder, options, multiple, otherProps, onValueChange = () => undefined, onEditItem, onOpenItem, } = props;
    const classes = useStyles();
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const [listItems, setListItems] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (value) {
            setListItems(value);
            setFieldValue(name, value.map((item) => item.value));
        }
    }, []);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 1 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Autocomplete_1.default, { classes: { input: classes.input }, options: options, onChange: (event, newInputValue) => {
                        if (newInputValue.length === 0) {
                            setListItems([]);
                            setFieldValue(name, []);
                        }
                        else {
                            const data = listItems;
                            newInputValue.forEach((element) => {
                                if (!data.find((item) => item.value === element.value))
                                    data.push(element);
                            });
                            setListItems(data);
                            setFieldValue(name, data.map((item) => item.value));
                        }
                        onChange(event);
                        onValueChange(event, newInputValue);
                    }, multiple: multiple, onBlur: onBlur, value: listItems, getOptionLabel: (option) => option.label, getOptionSelected: (option, value) => {
                        return !!listItems.find((item) => item.value === option.value);
                    }, renderTags: () => null, renderInput: (params) => (react_1.default.createElement(core_1.TextField, { ...params, name: name, variant: "filled", placeholder: placeholder, error: touch && !!error, fullWidth: true, label: label, onBlur: (event) => {
                            onBlur(event);
                        } })), ...otherProps })),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(core_1.Typography, { variant: "subtitle1" },
                    listTitleDesc,
                    " ",
                    listItems.length,
                    " ",
                    listTitleItem)),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(OrderedList_1.default, { listItems: listItems, isFile: isFile, onChange: (res) => {
                        if (!res.destination)
                            return;
                        const items = Array.from(listItems);
                        const [reorderedItem] = items.splice(res.source.index, 1);
                        items.splice(res.destination.index, 0, reorderedItem);
                        setFieldValue(name, items.map((item) => item.value));
                        setListItems(items);
                    }, onEditItem: onEditItem, onDeleteItem: (value, index) => {
                        const data = [];
                        listItems.forEach((item) => {
                            if (item.value !== value)
                                data.push(item);
                        });
                        setListItems(data);
                        setFieldValue(name, data.map((item) => item.value));
                    }, onOpenItem: onOpenItem })))));
};
RenderOrderedAutocompleteField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    multiple: prop_types_1.default.bool,
    options: prop_types_1.default.array.isRequired,
    onValueChange: prop_types_1.default.func,
};
exports.default = RenderOrderedAutocompleteField;
